export function doArraysHaveSameValues<T>(firstArray: T[], secondArray: T[]): boolean {
  if (firstArray.length !== secondArray.length) {
    return false;
  } else {
    const firstSortedArrayWithoutDuplicates = [...new Set(firstArray)].sort();
    const secondSortedArrayWithoutDuplicates = [...new Set(secondArray)].sort();

    for (let i = 0; i < firstSortedArrayWithoutDuplicates.length; i++) {
      if (firstSortedArrayWithoutDuplicates[i] !== secondSortedArrayWithoutDuplicates[i]) {
        return false;
      }
    }

    return true;
  }
}
